// gstSuffix — single source of truth for the bracketed GST hint that
// trails dollar values on every contract surface (milestone summary
// cards, milestone table column headers, contract detail page,
// contract register, etc.).
//
// Three states matching the contract's `gstApplies` field:
//
//   true       → "ex-GST"
//   false      → "no GST"
//   undefined  → "GST status not recorded"  (legacy / unset)
//
// Procurement managers tick the GST box on the contract details form
// once GST status is confirmed; until then, the "GST status not
// recorded" placeholder makes the unfilled state visible rather than
// silently rendering an unsafe "ex-GST" assumption.
//
// Related helper (kept inline at the call site rather than centralised
// to avoid premature abstraction): inc-GST = ex-GST × 1.1 in AU. Used
// by the contract detail page when both ex- and inc-GST values are
// shown side-by-side; not used on milestone surfaces (those are
// ex-GST-only per CGN milestone redesign feedback).

export function gstSuffix(gstApplies: boolean | undefined): string {
  if (gstApplies === true) return "ex-GST";
  if (gstApplies === false) return "no GST";
  return "GST status not recorded";
}
